import React from "react";
import AreaChart from "../../../../components/charts/areaChart/areaChart";
import { useSelector } from "react-redux";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

const YearOverYear = () => {
  const yearOverYearComparison = useSelector((state) => state.totalRevenue.yearOverYearComparison);
  const isChartLoading = useSelector((state) => state.totalRevenue.isChartLoading);
  const currencySymbol = useSelector((state) => state.totalRevenue.allRevenues.currencySymbol);
  const rolling_view = useSelector((state) => state.totalRevenue.rolling_view);

  const chartDataKeys = rolling_view
    ? {
        currentDataKey: "current",
        previousDataKey: "previous"
      }
    : {};

  return isChartLoading ? (
    <div className="chart-loading">
      <LoadingAnimation />
    </div>
  ) : (
    <AreaChart
      {...chartDataKeys}
      chartData={yearOverYearComparison}
      width={675}
      currencySymbol={currencySymbol}
    />
  );
};

export default YearOverYear;
